<template>
    <div>
        <!-- <b-modal id="modal-to-items" @hide="fetch_init" scrollable title="TRANSFER ORDER" size="xl" hide-footer style="min-height: 700px;">
            <TransferOrderModal v-on:done-items-co="close_to_modal" style="min-height: 700px;" :viewdata="{id: transfer_order_id, products: products}" />
        </b-modal>

        <b-alert show>
            <b-button size="sm" variant="success" @click="add_new_to">ADD NEW</b-button>
                <b-button size="sm" variant="primary" @click="fetch_init">RELOAD</b-button>
        </b-alert> -->

        <b-alert show variant="dark">
            <b-button size="sm" variant="primary" @click="get_transfer_orders_pullist">
                <span v-if="items.length === 0">LOAD ORDERS</span>
                <span v-else>RELOAD</span>
            </b-button>

            <div v-if="this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id" style="display: inline-block; vertical-align: top;">
                <!-- <b-card-text>PULL FROM</b-card-text> -->
                <b-form-select style="width: 300px;" size="sm" :options="locations" v-model="location_id"
                    v-on:change="onChangePullFrom">
                    <template #first>
                        <b-form-select-option :value="null" disabled>-- PULL FROM --</b-form-select-option>
                    </template>
                </b-form-select>
            </div>

            <div style="display: inline-block; vertical-align: top;" v-if="location_id">
                <!-- <b-card-text>PULL DATES</b-card-text> -->
                <date-picker v-model="date_range" format="MM-DD-YYYY" valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE" range v-on:change="get_transfer_orders_pullist"></date-picker>
            </div>

            <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                <!-- <b-card-text>&nbsp; </b-card-text> -->
                <!-- <b-button size="sm" variant="success">DOWNLOAD EXCEL</b-button> -->
                <download-csv class="btn" :data="get_csv_data()"
                    style="width: auto; padding: 3px; background: #28a745; color: white; " :name="get_csv_filename()">

                    DOWNLOAD EXCEL

                </download-csv>
            </div>


        </b-alert>

        <div v-if="location_id">
            <div v-if="items_being_loaded == true">
                <loading :active="true" :can-cancel="false" :is-full-page="true">
                </loading>
            </div>

            <div v-else>
                <div v-if="items_being_loaded == false">
                    <div v-if="items.length == 0">
                        <b-alert show variant="warning">NO TRANSFER ORDERS TO PULL.</b-alert>
                    </div>

                    <div v-else>
                        <b-card-text>
                            <b-badge
                                :style="{ background: background_colors[1], color: 'black', border: '1px solid gray' }">ORDERED</b-badge>
                            <b-badge
                                :style="{ background: background_colors[2], color: 'black', border: '1px solid gray' }">PULLED</b-badge>
                        </b-card-text>
                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <td class="srr" style="width: 80px;" @click="sortby('transfer_order_id')">ORDER #
                                    </td>
                                    <td class="srr" style="width: 200px;" @click="sortby('ordering_location')">ORDERING
                                        LOCATION</td>
                                    <td class="srr" style="width: 200px;" @click="sortby('selling_location')">SELLING
                                        LOCATION</td>
                                    <td class="srr" style="width: 200px;" @click="sortby('product_sku')">SKU</td>
                                    <td class="srr" style="width: 350px;" @click="sortby('product_name')">PRODUCT NAME
                                    </td>
                                    <td class="srr" style="width: 180px;" @click="sortby('vendor_id')">VENDOR</td>
                                    <td class="srr" style="width: 70px;" @click="sortby('quantity')">QTY</td>
                                    <td class="srr" style="width: 200px;" @click="sortby('truck', packet.trucksdict)">
                                        TRUCK</td>
                                    <td class="srr" style="width: 150px;" @click="sortby('delivery_date')">DELIVERY DATE
                                    </td>
                                    <td class="srr" style="width: 150px;" @click="sortby('status')">STATUS</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item, idx in items" v-bind:key="idx"
                                    :style="{ background: background_colors[item.status] }"
                                    onMouseOver="this.style.fontWeight='bold'"
                                    onMouseOut="this.style.fontWeight='normal'"
                                    :disabled="[3, 4, 5, 6].includes(item.status)">
                                    <td class="srrv">{{ item.transfer_order_id }}</td>
                                    <td class="srrv">
                                        {{ packet.locationsdict[item.ordering_location] }}
                                    </td>
                                    <td class="srrv">
                                        {{ packet.locationsdict[item.selling_location] }}
                                    </td>

                                    <td class="srrv">
                                        {{ item.product_sku }}
                                    </td>

                                    <td class="srrv">
                                        {{ item.product_name }}
                                    </td>

                                    <td class="srrv">
                                        {{ packet.vendorsdict[item.vendor_id] }}
                                    </td>

                                    <td class="srrv">
                                        {{ item.quantity }}
                                    </td>

                                    <td class="srrv">
                                        {{ packet.trucksdict[item.truck] }}
                                    </td>

                                    <td class="srrv">
                                        {{ item.delivery_date }}
                                    </td>

                                    <td class="srrv">
                                        <b-form-select v-model="item.status" :options="statuses"
                                            v-on:change="update_transfer_order_item_status(item)"></b-form-select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else>

                </div>
            </div>
        </div>


    </div>
</template>
<script>
import moment from 'moment'
import mappings from '@/utilities/mappings'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

//import TransferOrderModal from '@/components/TransferOrders/TransferOrderModal';

export default {
    name: "PullTransferOrders",
    props: [],
    components: { flatPickr, Loading, DatePicker },
    data: function () {
        return {
            packet: {},
            userLocationId: '',
            items: [],
            items_being_loaded: null,
            locations: [],
            sort_asc: true,
            location_id: null,
            date_range: [],
            statuses: [
                { value: 1, text: "ORDERED", disabled: false },
                { value: 2, text: "PULLED", disabled: false },
                { value: 3, text: "SHIPPED", disabled: false },
                { value: 4, text: "DELIVERED", disabled: true },
                { value: 5, text: "RECEIVED", disabled: true },
                { value: 6, text: "NOT RECEIVED", disabled: true },
            ],
            background_colors: {
                1: 'white',
                2: 'lightyellow',
                3: 'rgb(141 239 205)',
                4: 'rgb(251 240 171)',
                5: 'rgb(201 251 171)',
                6: 'rgb(255 200 200)'
            }
        }
    },
    methods: {
        get_csv_data: function () {
            let that = this;
            return this.items.map(function (d) {
                return {
                    "ORDER_ID": d.transfer_order_id,
                    "PULL_FROM": that.packet.locationsdict[d.selling_location],
                    "PRDOUCT_SKU": d.product_sku,
                    "PRODUCT_NAME": d.product_name,
                    "QTY": d.quantity,
                    "VENDOR": that.packet.vendorsdict[d.vendor_id],
                    "DELIVERY_DATE": d.delivery_date
                }
            })
        },
        get_csv_filename: function () {
            let location = (this.packet.locationsdict[this.location_id] || 'N_A').replace(" ", "_");
            return location + "_TORDER_PULLIST.csv"
        },
        update_transfer_order_item_status: function (item) {
            let path = "/api/sales/update_transfer_order_item_status/"
            let data = { id: item.id, transfer_order_id: item.transfer_order_id, status: item.status }
            let that = this;
            let s = function (response) {
                if (response.data.error) {
                    that.$bvToast.toast(
                        "ERROR UPDATING TRANSFER ITEM STATUS.",
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
                else {
                    that.$bvToast.toast(
                        "UPDATED TRANSFER ITEM STATUS.",
                        { title: "Success", autoHideDelay: 1500, variant: "success" }
                    );
                }
            }

            let f = function (error) {
                that.$bvToast.toast(
                    "ERROR OCCURRED. TRY AGAIN LATER.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
            }
            Requestor.getSyncP(path, data, this, s, f);
        },
        get_transfer_orders_pullist: function () {
            if (this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id && !this.location_id) {
                this.$vex.dialog.alert({
                    message: "PICK A PULL FROM LOCATION"
                });
                return;
            };
            let path = "/api/sales/get_transfer_orders_pullist/"
            let data = { date_range: this.date_range.filter(d => d !== null), location_id: this.location_id }
            let that = this;
            let s = function (response) {
                if (response.data.error) {
                    that.$bvToast.toast(
                        "ERROR LOADING TRANSFER ORDERS PULLIST.",
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
                else {
                    that.items = response.data.result;
                }
                that.items_being_loaded = false;
            }

            let f = function (error) {
                that.$bvToast.toast(
                    "ERROR OCCURRED (PULLIST). TRY AGAIN LATER.",
                    { title: "Error", autoHideDelay: 1500, variant: "danger" }
                );
                that.items_being_loaded = false;
            }
            this.items_being_loaded = true;
            Requestor.postSyncP(path, data, this, s, f);
        },
        get_current_time: function () {
            return moment().format("MM-DD-YYYY hh:mm:ss")
        },
        sortby: function (key, mapper) {
            if (this.sort_asc) {
                this.items = Requestor.sort(this.items, key, mapper)
            }
            else {
                this.items = Requestor.sort_reverse(this.items, key, mapper)
            }
            this.sort_asc = !this.sort_asc;
        },
        onChangePullFrom: function() {
            this.date_range = [];
            if (this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id) {
                this.get_transfer_orders_pullist();
            }
        },
    },
    created: function () {
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);
        if (
            this.packet &&
            this.packet.userDetails &&
            this.packet.userDetails.userrole !== 'admin'
        ) {
            this.userLocationId =
                this.packet.userDetails.properties &&
                this.packet.userDetails.properties.location_id;
        } else {
            this.userLocationId = null;
        }
        if (this.packet &&
            this.packet.userDetails &&
            this.packet.userDetails.userrole == 'admin'){
                this.locations = this.packet.locations.filter(function (d) { return d.is_main_warehouse == true });
            }
            else{
                this.locations = this.packet.locations.filter(d => Number(d.value) === Number(this.userLocationId)
);
            }
        if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
            let userLocation = this.packet.locations.find(item => [this.packet.userDetails.properties.location_id].includes(item.value))
            if (userLocation) {
                this.location_id = userLocation.value;
                this.get_transfer_orders_pullist();
            }
        };
    }
}
</script>


<style scoped>
.srr {
    font-size: 14px;
    text-align: center;
    background: #ffeaa7;
    border: 1px solid #010101;
    font-weight: bold;
}

.srrv {
    font-size: 14px;
    text-align: center;

    border: 1px solid #010101;
    padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/TransferOrders/PullTransferOrders.vue